import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../../../app.component";
import { DataService, Response } from "./../../../dataService/data.service";
import { CommonService } from "./../../../services/common.service";
import { DATE_FORMATS } from "./../../../services/utils";
@Component({
  selector: "app-tile-recent-widget",
  templateUrl: "./tile-recent-widget.component.html",
  styleUrls: [
    "./tile-recent-widget.component.scss",
    "./../../recent-reviews/recent-reviews.component.scss",
  ],
})
export class TileRecentWidgetComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  appointmentDetail: any;
  DATE_FORMATS = DATE_FORMATS;
  recentAppointments: any;
  isAppointment: boolean;
  mystoreDetail: any;
  recentOrders: any;
  outlet_id: string;
  @Input() data: any;
  @Input() mystoreData: any;
  @Input() isAnyAppointmentData: boolean;

  constructor(
    private router: Router,
    private HttpService: DataService,
    private commonService: CommonService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outlet_id = this.storage.get("outlet_id");
    if (this.router.url === "/dashboard/mystore") {
      this.getOrderDetails();
    } else if (this.router.url === "/dashboard/appointments") {
      this.getAppointmentDetails();
    }
    console.log(this.data);
  }
  getAppointmentDetails() {
    let res: Response;
    // this.HttpService.getRequest({ customApiUrl: this.BASE_URL.VIEW_APPOINTMENT_BOTTOM_TILE(this.outlet_id) })
    // this.commonService.appointment_bottom_panel.subscribe(data => {
    //     res = data;
    //     console.log(data);

    //     if (res.code === 200 && res != null) {
    //       console.log(res.data);
    //       this.appointmentDetail = res.data;
    //       this.recentAppointments = this.appointmentDetail.appointment_details;
    //       this.isAppointment = true;
    //       this.loading = false;
    //     };
    //   });

    if (this.data) {
      console.log(this.data.data);
      this.appointmentDetail = this.data.data;
      this.recentAppointments = this.appointmentDetail.appointment_details;
      this.isAppointment = true;
      this.loading = false;
    }
  }

  getOrderDetails() {
    let res;
    // this.HttpService.getRequest({ customApiUrl: this.BASE_URL.VIEW_MYSTORE_BOTTOM_TILE(this.outlet_id) })
    res = this.mystoreData;
    if (res) {
      if (res.code == 200) {
        this.mystoreDetail = res.data;
        this.recentOrders = this.mystoreDetail.order_details;
        this.isAppointment = false;
        this.loading = false;
      }
    }
  }

  redirectToAppointment() {
    this.router.navigate([`/appointments`]);
    this.commonService.appointmentTab.next(1);
  }
  redirectToMystore() {
    this.router.navigate([`/mystore`]);
  }
}
